var isNotNull = function isNotNull(value) {
  return value !== null;
};
function getFinalKeyframe(keyframes, _ref, finalKeyframe) {
  var repeat = _ref.repeat,
    _ref$repeatType = _ref.repeatType,
    repeatType = _ref$repeatType === void 0 ? "loop" : _ref$repeatType;
  var resolvedKeyframes = keyframes.filter(isNotNull);
  var index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
  return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}
export { getFinalKeyframe };